
export default {
    data () {
        return {
            questionnaireData: {
                questionList: []
            }, // 问卷信息
            rules: {},
            loading: false,
            evaluateIconIndex: null,
            submitData: {},
            orderId: null,
            evaluateSubmitNum: 3, // 提交倒计时
            timer: null, // 提交倒计时
            submitState: false,
            submitTip: ''
        }
    },
    computed: {},
    mounted () {
        this.orderId = this.$route.query.orderId
        this.getQuestionnaireDetail()
    },
    methods: {
        // 获取问卷详情数据
        getQuestionnaireDetail () {
            const data = {
                questionnaireId: this.$route.query.id,
                orderId: this.orderId
            }
            this.$api.questionnaireDetail(data).then((res) => {
                if (res.success) {
                    res.data.questionList.map((item) => {
                        item.value = ''
                        if (item.type == 2) {
                            item.value = []
                        }
                        if (item.type == 3) {
                            item.answers[0].img = 'https://oss.pzds.com/pc-ssr-im/evaluate1.png'
                            item.answers[0].active = 'https://oss.pzds.com/pc-ssr-im/evaluate11.png'

                            item.answers[1].img = 'https://oss.pzds.com/pc-ssr-im/evaluate2.png'
                            item.answers[1].active = 'https://oss.pzds.com/pc-ssr-im/evaluate22.png'

                            item.answers[2].img = 'https://oss.pzds.com/pc-ssr-im/evaluate3.png'
                            item.answers[2].active = 'https://oss.pzds.com/pc-ssr-im/evaluate33.png'

                            item.answers[3].img = 'https://oss.pzds.com/pc-ssr-im/evaluate4.png'
                            item.answers[3].active = 'https://oss.pzds.com/pc-ssr-im/evaluate44.png'

                            item.answers[4].img = 'https://oss.pzds.com/pc-ssr-im/evaluate5.png'
                            item.answers[4].active = 'https://oss.pzds.com/pc-ssr-im/evaluate55.png'
                        }
                    })
                    this.questionnaireData = res.data
                } else {
                    this.$message.error(res.info)
                    this.submitTip = res.info
                    this.questionnaireData = null
                    this.submitState = false
                    this.timer = setInterval(() => {
                        --this.evaluateSubmitNum
                        if (this.evaluateSubmitNum == 0) {
                            clearTimeout(this.timer)
                            this.$router.push({
                                path: '/'
                            })
                        }
                    }, 500)
                }
            })
        },
        // 选择满意度
        evaluateIconClick (v, i) {
            this.evaluateIconIndex = i
        },
        // 提交问卷
        onSubmit () {
            const submitData = []
            this.questionnaireData.questionList.map((item) => {
                if (item.type == 1) {
                    item.answers.map((ites) => {
                        if (ites.key == item.value) {
                            submitData.push({
                                key: item.key,
                                selects: [ites.key],
                                value: ''
                            })
                        }
                    })
                }
                if (item.type == 2) {
                    const checkData = []
                    item.answers.map((ites) => {
                        item.value.map((v) => {
                            if (v == ites.key) {
                                checkData.push(ites.key)
                            }
                        })
                    })
                    submitData.push({
                        key: item.key,
                        selects: checkData,
                        value: ''
                    })
                }
                if (item.type == 3) {
                    item.answers.map((ites) => {
                        if (ites.seq == item.value) {
                            submitData.push({
                                key: item.key,
                                selects: [ites.key],
                                value: ''
                            })
                        }
                    })
                }
                if (item.type == 4) {
                    submitData.push({
                        key: item.key,
                        selects: [],
                        value: item.value
                    })
                }
            })
            const data = {
                answers: submitData,
                orderId: this.orderId,
                questionnaireId: this.$route.query.id
            }
            this.loading = true
            this.$refs.questionnaireData.validate((valid) => {
                if (valid) {
                    this.$api.questionnaireSubmit(data).then((res) => {
                        if (res.success) {
                            this.loading = false
                            this.questionnaireData = null
                            this.submitState = true
                            this.timer = setInterval(() => {
                                --this.evaluateSubmitNum
                                if (this.evaluateSubmitNum == 0) {
                                    clearTimeout(this.timer)
                                    this.$router.push({
                                        path: '/'
                                    })
                                }
                            }, 1000)
                        } else {
                            this.loading = false
                            this.$message.error(res.info)
                        }
                    })
                } else {
                    this.loading = false
                }
            })
        },

        valueChange (val) {
            this.questionnaireData.questionList.map((item) => {
                if (item.type == 3) {
                    item.value = val
                }
            })
        }
    }
}
